import { fetchAuthSession } from "aws-amplify/auth";
import { environment, getCDN } from "./consts";

interface FontConversionParams {
  file: string; // base64 encoded OTF or TTF font data without prefix
  key: string; //  S3 key name in form projectId/... (without public/projects)
}

interface ImageConversionParams {
  file: string; // base64 encoded image data
  key: string; //  S3 key name in form projectId/... (without public/projects)
}
const prefix = "https://cors.blings.io/"; // to avoid CORS issues
const API_URLS = {
  font: {
    development:
      "https://5ptkfkesj2.execute-api.eu-west-1.amazonaws.com/dev/v1/private/convert/font",
    production:
      "https://2zlmm87lee.execute-api.eu-west-1.amazonaws.com/master/v1/private/convert/font",
  },
  image: {
    development:
      "https://tee1st7f3d.execute-api.eu-west-1.amazonaws.com/dev/v1/private/convert/image",
    production:
      "https://xtt82dfuj8.execute-api.eu-west-1.amazonaws.com/master/v1/private/convert/image",
  },
};

const getAuthorizationHeaderValue = async () => {
  try {
    const authSession = await fetchAuthSession();
    const accessToken = authSession.tokens?.accessToken.toString() as string;
    return accessToken;
  } catch (error) {
    console.error("Error retrieving authorization header value:", error);
  }
};

export async function convertFontToWoff2(params: FontConversionParams) {
  const fileExists = await checkIfFileExists(
    params.key.replace(/\.[^\.]+$/, ".woff2")
  );
  if (fileExists) {
    return { key: params.key.replace(/\.[^\.]+$/, ".woff2") };
  }
  const endpoint = prefix + API_URLS.font[environment];
  const accessToken = await getAuthorizationHeaderValue();
  if (!accessToken) throw new Error("Invalid id or authorization");

  const data = {
    key: params.key,
  };
  const response = await fetch(endpoint, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      Authorization: accessToken,
    },
  });

  const res = await response.json();
  return { key: res.publicKey?.woff2 || res.publicKey?.woff };
}

export async function convertImageToWebP(params: ImageConversionParams) {
  const fileExists = await checkIfFileExists(
    params.key.replace(/\.[^\.]+$/, ".webp")
  );
  if (fileExists) {
    return { key: params.key.replace(/\.[^\.]+$/, ".webp") };
  }
  const endpoint = prefix + API_URLS.image[environment];
  const accessToken = await getAuthorizationHeaderValue();
  if (!accessToken) throw new Error("Invalid id or authorization");

  const data = {
    key: params.key,
  };

  const response = await fetch(endpoint, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      Authorization: accessToken,
    },
  });
  const res = await response.json();
  return { key: res.publicKey.webp };
}

export const checkIfFileExists = async (Key: string) => {
  try {
    const url = `${getCDN()}/${Key}`;
    const response = await fetch(url, {
      method: "HEAD",
      referrer: "no-referrer",
    });

    switch (response.status) {
      case 200:
        return true;
      case 404:
        return false;
      default:
        throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (e) {
    console.log("File likely does not exist:", e);
    return false;
  }
};
